module.exports = __webpack_public_path__ + "static/media/no-image-circle.4e8e680e.png";